import { render, staticRenderFns } from "./ConfirmacionBuro.vue?vue&type=template&id=76c26042&scoped=true&"
import script from "./ConfirmacionBuro.vue?vue&type=script&lang=js&"
export * from "./ConfirmacionBuro.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmacionBuro.vue?vue&type=style&index=0&id=76c26042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c26042",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VCard,VDivider,VIcon,VLayout,VListItem,VListItemContent,VListItemTitle,VSubheader})
